import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Quote } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WavyDivider } from '../components/WavyDivider';
import { useSeo } from '../lib/useSeo';
import { testimonies } from '../data/testimonies';
export function Testimonies() {
  useSeo({
    title: 'Testimonies',
    description: "Read what people share about their experiences with Milangela's Soul Garden. Stories of healing, clarity, and transformation.",
    path: '/testimonies',
    image: 'https://images.unsplash.com/photo-1500964757637-c85e8a162699?auto=format&fit=crop&q=80&w=2000'
  });
  const location = useLocation();
  // Scroll to anchor if hash is present
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        }), 100);
      }
    }
  }, [location]);
  return <div className="min-h-screen flex flex-col bg-cream" data-id="element-669">
      <Header data-id="element-670" />

      {/* Hero */}
      <section className="relative h-[65vh] min-h-[480px] flex items-center justify-center overflow-hidden" data-id="element-671">
        <div className="absolute inset-0 z-0" data-id="element-672">
          <img src="https://images.unsplash.com/photo-1500964757637-c85e8a162699?auto=format&fit=crop&q=80&w=2000" alt="Soft forest light" className="w-full h-full object-cover" data-id="element-673" />
          <div className="absolute inset-0 bg-charcoal/35" data-id="element-674"></div>
        </div>
        <div className="relative z-10 text-center px-6 mt-16" data-id="element-675">
          <h1 className="text-5xl md:text-7xl font-serif text-white mb-4 drop-shadow-md" data-id="element-676">
            Testimonies
          </h1>
          <p className="text-xl md:text-2xl text-white/90 font-serif italic drop-shadow-md max-w-2xl mx-auto" data-id="element-677">
            Stories of presence, resonance, and quiet transformation.
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none" data-id="element-678">
          <WavyDivider fill="#F8F2E4" data-id="element-679" />
        </div>
      </section>

      {/* Testimonies */}
      <section className="py-20 px-6" data-id="element-680">
        <div className="max-w-3xl mx-auto space-y-16" data-id="element-681">
          {testimonies.map(t => <article key={t.id} id={t.id} className="bg-white rounded-3xl shadow-soft p-10 md:p-14 scroll-mt-32" data-id="element-682">
              <Quote size={36} strokeWidth={1} className="text-rose-600 mb-6" aria-hidden="true" data-id="element-683" />
              <div className="font-serif text-charcoal text-lg md:text-xl italic leading-relaxed space-y-5 whitespace-pre-line" data-id="element-684">
                {t.full}
              </div>
              <div className="mt-8 pt-6 border-t border-cream-200" data-id="element-685">
                <p className="font-serif text-2xl text-charcoal" data-id="element-686">{t.name}</p>
                {t.location && <p className="text-sm text-charcoal-50 tracking-wide mt-1" data-id="element-687">
                    {t.location}
                  </p>}
              </div>
            </article>)}
        </div>
      </section>

      {/* Divider into footer */}
      <div className="relative bg-cream" data-id="element-688">
        <WavyDivider fill="#3A3A38" data-id="element-689" />
      </div>

      <Footer data-id="element-690" />
    </div>;
}